import { usePublicViewContext } from "../../context/usePublicViewContext"
import { useSaveCustomer } from "./useSaveCustomer"
import { useState } from "react"
import { AddressEntity } from "../../Objects/Person/AddressEntity"
import { PersonEntity } from "../../Objects/Person/PersonEntity"
import { CustomerEntity } from "../../Objects/Customer/CustomerEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"

export const useCustomerAddresses = (restaurantSlug: string) => {
  const { auth, updateCustomer } = usePublicViewContext()
  const { handleSavePublicCostumer } = useSaveCustomer()

  const [addresses, setAddresses] = useState<AddressEntity[]>(auth.customer?.personEntity?.addresses ?? [])

  const [selectedAddress, setSelectedAddress] = useState<AddressEntity | null>(null)
  const [showAddressModal, setShowAddressModal] = useState(false)

  const saveAddresses = (newAddresses: AddressEntity[]) => {
    const person: PersonEntity = new PersonEntity(auth.customer.personEntity)
    const customer: CustomerEntity = new CustomerEntity(auth.customer)

    person.addresses = newAddresses
    customer.personEntity = person

    handleSavePublicCostumer(
      API_ROUTES.CUSTOMER.PUT_CUSTOMER_ADDRESS_PUBLIC(restaurantSlug),
      customer,
      (updatedCustomer: CustomerEntity) => {
        updateCustomer(updatedCustomer)
        setAddresses(updatedCustomer.personEntity.addresses)
      },
    )
  }

  const addOrUpdateAddress = (list: AddressEntity[]) => {
    saveAddresses(list)
    setShowAddressModal(false)
    setSelectedAddress(null)
  }

  const deleteAddress = (address: AddressEntity) => {
    saveAddresses(addresses.filter((a) => a !== address))
  }

  return {
    addresses,
    selectedAddress,
    showAddressModal,

    openAddAddress: () => {
      setSelectedAddress(null)
      setShowAddressModal(true)
    },

    openEditAddress: (address: AddressEntity) => {
      setSelectedAddress(address)
      setShowAddressModal(true)
    },

    closeModal: () => {
      setShowAddressModal(false)
      setSelectedAddress(null)
    },

    addOrUpdateAddress,
    deleteAddress,
  }
}
